<template>
  <div class="principal-management">
    <el-form :inline="true" size="mini">
      <el-form-item label="学校名称">
        <span>{{ $route.query.name }}{{ "(" + $route.query.domain + ")" }}</span>
      </el-form-item>
    </el-form>
    <div class="table-style">

      <!-- <el-button size="mini" @click="addSchool" type="primary" icon="el-icon-plus">校长账号</el-button> -->

      <el-table style="margin-top:20px;" size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
        <!-- <el-table-column width="50" align="center" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + 20 * (page_no - 1) }}</span>
          </template>
        </el-table-column> -->
        <el-table-column align="left" prop="name" label="校区名称"></el-table-column>
        <el-table-column align="left" prop="max_teacher_num" label="教师数量"></el-table-column>

        <el-table-column align="left" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" label-position="left" size="small">
        <el-form-item label="最大教师数" required prop="max_teacher_num">
          <el-input-number v-model="form.max_teacher_num" :precision="0"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  adminGetSchoolCampusList,
  adminUpdateSchoolCampus

} from "@/api/admin";
export default {
  data() {
    return {
      form: {
        max_teacher_num: 0,
      },
      dialogVisible: false,
      tableData: [],
      rules: {

        max_teacher_num: [
          { required: true, message: "请输入排序号", trigger: "change" }
        ],
      }

    };
  },
  mounted() {
    this.adminGetSchoolCampusList()

  },
  methods: {
    quitDialog() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    },
    edit(row) {
      this.dialogVisible = true
      this.campusId = row.id
      this.form.max_teacher_num = row.max_teacher_num

    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          adminUpdateSchoolCampus({
            campusId: this.campusId,
            max_teacher_num: this.form.max_teacher_num
          }).then((res) => {
            console.log(res)
            this.dialogVisible = false
            this.$message.success('修改教师数量成功！')
            this.adminGetSchoolCampusList()
          })
        }
      });
    },

    adminGetSchoolCampusList() {
      adminGetSchoolCampusList({
        schoolId: this.$route.query.id
      }).then((res) => {
        this.tableData = res.campusList
        console.log(res, 1112)
      })
    },

  },
};
</script>

<style lang="scss" scoped>
.principal-management {
  height: 100%;
  box-sizing: border-box;
  padding-left: 20px;
  padding-top: 20px;
  margin: 10px;
  border-radius: 5px;
  background-color: #fff;
  padding-bottom: 20px;

  .form-style {
  }
  .btn {
    margin-top: 10px;
  }
}
</style>
